import React, { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ReactComponent as Loader } from '@blink/assets/src/icons/loaderDash.svg';

import { UserSuppliesSection } from './UserSuppliesSection';
import { useManageDetailsStyle } from './ManageDetails.style';
import { PATHS } from 'src/routes/paths';
import { ManageSection } from 'src/components/ManageSection';
import { AssetsToLendVaultSection } from './AssetsToLendVaultSection';
import ManageDetailsVisibilityWrapper from './ManageDetailsVisibilityWrapper';

import {
    AssetIcon,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator,
    Layout,
} from '@/shared/ui';
import { Faqs } from '@/widgets/FAQs';
import { useFetchVaults } from '@/shared/hooks/useFetchVaults';
import { ROLE } from '@/shared/api/vault';

export type Data = { [key: string]: string };

export const ManageDetails: FC = () => {
    const classes = useManageDetailsStyle();
    const { address } = useParams();

    const { vaults } = useFetchVaults();

    const currentVault = useMemo(() => {
        return vaults.filter(
            (vault) => vault.address === address && vault.role === ROLE.CURATOR,
        )[0];
    }, [vaults, address]);

    if (!currentVault) {
        return (
            <div className={classes.loader}>
                <Loader />
            </div>
        );
    }

    return (
        <ManageDetailsVisibilityWrapper>
            <div className={classes.top}>
                <div className={classes.breadcrumbs}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={PATHS.VAULTS}>Vaults</BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                <BreadcrumbLink href={PATHS.VAULTS_MANAGE}>
                                    <div>Manage</div>
                                </BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                <BreadcrumbLink href={PATHS.VAULTS_MANAGE + '/' + address}>
                                    <div className='font-semibold text-content-primary'>
                                        {currentVault?.title}
                                    </div>
                                </BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>
                </div>
            </div>
            <div className={classes.topTitle}>
                <div className={classes.heading}>
                    <div className={classes.title}>
                        <div className={classes.titleText}>
                            <AssetIcon assetName={currentVault?.leverage?.name} />{' '}
                            {currentVault?.title}
                        </div>
                    </div>
                </div>
            </div>

            <Layout>{currentVault ? <ManageSection vault={currentVault} /> : null}</Layout>

            <Layout>
                <UserSuppliesSection vault={currentVault} title={'My Positions'} />
                <AssetsToLendVaultSection vault={currentVault} />
            </Layout>
            <Faqs />
        </ManageDetailsVisibilityWrapper>
    );
};
